import { NavBarModelConfig } from "./models/nav-bar.model.config";

import { Privileges } from "../../shared/constants/privileges";
import { Roles } from "../../shared/constants/roles";
import { getActiveAdGroups } from "../../modules/login/util/constants";


export function getNavMenuLinks(): NavBarModelConfig[] {
    // Resolve AD groups for the active deployment environment
    const AD_GROUPS = getActiveAdGroups();

    return [
    {
        menuId: 'member',
        menuLabel: 'Member',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS, Privileges.MEMBER_RESTRICT, Privileges.MANAGE_SHIFTED_MEMBERS],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MEMBER_ADMIN, AD_GROUPS.MEMBER_REP, AD_GROUPS.MEMBER_PAYMENT_ADMIN],
        customerAssistanceTools: [
            {
                subMenuId: 'searchMemberAccount',
                subMenuLabel: 'Search Member Account',
                subMenuLink: '/member/search-member-account',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MEMBER_REP]
            },
            {
                subMenuId: 'manageEobDeliveryRestrictions',
                subMenuLabel: 'Manage EOB Delivery Restrictions',
                subMenuLink: '/member/manage-eob-delivery-restrictions',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MEMBER_REP]
            },
            {
                subMenuId: 'manageBillingDeliveryPreferences',
                subMenuLabel: 'Manage Billing Delivery Preferences',
                subMenuLink: '/member/manage-billing-delivery-preferences',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBERS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MEMBER_REP]
            },
            {
                subMenuId: 'memberPaymentResearch',
                subMenuLabel: 'Member Payment Research',
                subMenuLink: '/sso-redirection',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Roles.USER_MANAGER],
                ssoType: 'MemberPaymentResearch',
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MEMBER_PAYMENT_ADMIN]
            },
            {
                subMenuId: 'hicnMbiLookup',
                subMenuLabel: 'HICN MBI Lookup',
                subMenuLink: '/member/hicn-mbi-lookup',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.MEMBER_HICNMBI],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MEMBER_REP]
            },
            {
                subMenuId: 'ccm',
                subMenuLabel: 'CCM',
                subMenuLink: '/ccm',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_MEMBER, Privileges.CCM_PROSPECT, Privileges.CCM_PROVIDER, Privileges.CCM_PRODUCER, Privileges.CCM_EMPLOYER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MEMBER_REP]
            }
        ],
        adminTools: [
            {
                subMenuId: 'ifpProductData',
                subMenuLabel: 'IFP Product Data Upload',
                subMenuLink: '/member/ifp-product-data',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: true,
                accessIds: [Roles.SUPER_ADMIN],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MEMBER_ADMIN]
            }
        ]
    },
    {
        menuId: 'provider',
        menuLabel: 'Provider',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS, Privileges.PROVIDER_REPORTS],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PROVIDER_ADMIN, AD_GROUPS.PROVIDER_REP, AD_GROUPS.PROVIDER_REP_TAX],
        customerAssistanceTools: [
            {
                subMenuId: 'searchProviderAccount',
                subMenuLabel: 'Search Provider Account',
                subMenuLink: '/provider/search-provider-account',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PROVIDER_REP, AD_GROUPS.PROVIDER_REP_TAX]
            },
            {
                subMenuId: 'searchProviderRecord',
                subMenuLabel: 'Search Provider Record',
                subMenuLink: '/provider/search-provider-record',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDERS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PROVIDER_REP, AD_GROUPS.PROVIDER_REP_TAX]
            }
        ],
        adminTools: [
            {
                subMenuId: 'providerReports',
                subMenuLabel: 'Provider Reports',
                subMenuLink: '/provider/provider-reports',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.PROVIDER_REPORTS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PROVIDER_ADMIN]
            }
        ]
    },
    {
        menuId: 'employer',
        menuLabel: 'Employer',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS, Privileges.CWS_BUS, Privileges.CWS_TECH, Privileges.EMPLOYER_SURVEY_REPORT],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_ADMIN, AD_GROUPS.EMPLOYER_REP, AD_GROUPS.EMPLOYER_RPT],
        customerAssistanceTools: [
            {
                subMenuId: 'searchEmployerUser',
                subMenuLabel: 'Search Employer User',
                subMenuLink: '/employer/search-employer-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_REP]
            },
            {
                subMenuId: 'searchEmployerGroups',
                subMenuLabel: 'Search Employer Groups',
                subMenuLink: '/employer/search-employer-groups',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_REP]
            },
            {
                subMenuId: 'exceptionList',
                subMenuLabel: 'Exception List',
                subMenuLink: '/employer/exception-list',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_REP]
            },
            {
                subMenuId: 'registrationReport',
                subMenuLabel: 'Registration Report',
                subMenuLink: '/employer/registration-report',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPLOYERS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_REP]
            },
            {
                subMenuId: 'paymentReport',
                subMenuLabel: 'Payment Report',
                subMenuLink: '/employer/payment-report',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.EMPL_BILLING_ACCESS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_REP]
            },
            {
                subMenuId: 'healthcareSpendingReport',
                subMenuLabel: 'Prescription Drug and Healthcare Spending Report',
                subMenuLink: '/employer/healthcare-spending-report',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.EMPLOYER_SURVEY_REPORT],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_RPT]
            },
            {
                subMenuId: 'medicalLossRatioReport',
                subMenuLabel: 'Medical Loss Ratio Report',
                subMenuLink: '/employer/medical-loss-ratio-report',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.EMPLOYER_MLR_REPORT],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_RPT]
            }
        ],
        adminTools: [
            {
                subMenuId: 'createExternalReportingAdmin',
                subMenuLabel: 'Create External Reporting Admin',
                subMenuLink: '/employer/create-reporting-admin',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.ADMIN, Roles.REPRESENTATIVE, Roles.SUPER_ADMIN, Privileges.REPORTADMIN_IN_BSC],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_ADMIN]
            },
            {
                subMenuId: 'whyzenEmployerReporting',
                subMenuLabel: 'Whyzen Employer Reporting',
                subMenuLink: 'callWhyzenSso',
                linkType: 'method',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.ADMIN, Roles.REPRESENTATIVE, Roles.SUPER_ADMIN],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_ADMIN]
            },
            {
                subMenuId: 'manageWhyzenAccess',
                subMenuLabel: 'Manage Whyzen Access',
                subMenuLink: '/employer/manage-whyzen-access',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.EMPLOYER_ADMIN]
            }
        ]
    },
    {
        menuId: 'selfFunded',
        menuLabel: 'Self-Funded Portal',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Privileges.TPA_CREATEUSER, Privileges.TPA_SEARCH, Privileges.TPA_EXTERNAL_NOTIFICATIONS, Privileges.TPA_USER_DASHBOARD],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.TPA_REP, AD_GROUPS.SELF_FUNDED_ADMIN],
        customerAssistanceTools: [
            {
                subMenuId: 'searchUser',
                subMenuLabel: 'Search User',
                subMenuLink: '/self-funded/search-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_SEARCH],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.TPA_REP]
            },
            {
                subMenuId: 'userDashboard',
                subMenuLabel: 'User Dashboard',
                subMenuLink: '/self-funded/user-dashboard',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_USER_DASHBOARD],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.TPA_REP]
            }
        ],
        adminTools: [
            {
                subMenuId: 'createOrModifyUser',
                subMenuLabel: 'Create/Modify User',
                subMenuLink: '/self-funded/create-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_CREATEUSER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.SELF_FUNDED_ADMIN]
            },
            {
                subMenuId: 'registerEmailDomain',
                subMenuLabel: 'Register Email Domain',
                subMenuLink: '/self-funded/email-domains',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_CREATEUSER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.SELF_FUNDED_ADMIN]
            },
            {
                subMenuId: 'externalNotifications',
                subMenuLabel: 'External Notifications',
                subMenuLink: '/self-funded/create-notification',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Privileges.TPA_EXTERNAL_NOTIFICATIONS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.SELF_FUNDED_ADMIN]
            },
            {
                subMenuId: 'manageInternalTpaUser',
                subMenuLabel: 'Manage Internal TPA User',
                subMenuLink: '/self-funded/manage-internal-tpa-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.SELF_FUNDED_ADMIN]
            }
        ]
    },
    {
        menuId: 'producer',
        menuLabel: 'Broker',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PRODUCER_ADMIN, AD_GROUPS.PRODUCER_REP, AD_GROUPS.PRODUCER_DSA],
        customerAssistanceTools: [
            {
                subMenuId: 'manageProducerUser',
                subMenuLabel: 'Manage Broker User',
                subMenuLink: '/producer/manage-producer-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_SEARCH_PRODUCER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PRODUCER_REP]
            },
            {
                subMenuId: 'brokerConnection',
                subMenuLabel: 'Broker Connection',
                subMenuLink: '/sso-redirection',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_DIRECT_SALES_AGENT],
                ssoType: 'broker',
                adGroupAccessIds: [AD_GROUPS.PRODUCER_DSA]
            },
            {
                subMenuId: 'brokerConnection',
                subMenuLabel: 'Broker Connection',
                subMenuLink: '/sso-redirection',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_ADMIN],
                ssoType: 'broker',
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PRODUCER_REP]
            }
        ],
        adminTools: [
            {
                subMenuId: 'createNewBrokerAnalyst',
                subMenuLabel: 'Create New Broker Analyst',
                subMenuLink: '/producer/create-broker-analyst',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.PRODUCER_NEW_BROKER_ANALYST],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PRODUCER_ADMIN]
            },
            {
                subMenuId: 'generateBrokerReports',
                subMenuLabel: 'Generate Broker reports',
                subMenuLink: '/producer/generate-broker-reports',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Privileges.PRODUCER_GENERATE_BROKER_REPORTS],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PRODUCER_ADMIN]
            },
            {
                subMenuId: 'manageDSAUser',
                subMenuLabel: 'Manage DSA User',
                subMenuLink: '/producer/manage-dsa-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN,AD_GROUPS.PRODUCER_ADMIN]
            }
        ]
    },
    {
        menuId: 'prospect',
        menuLabel: 'Prospect',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: 'ADMIN TOOLS',
        accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PROSPECT_ADMIN, AD_GROUPS.PROSPECT_REP],
        customerAssistanceTools: [
            {
                subMenuId: 'ifpEnrollments',
                subMenuLabel: 'IFP enrollments',
                subMenuLink: '/sso-redirection',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
                ssoType: 'broker',
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PROSPECT_REP]
            },
            {
                subMenuId: 'userAccountActivation',
                subMenuLabel: 'User Account Activation',
                subMenuLink: '/prospect/user-account-activation',
                linkType: 'route',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Privileges.SEARCH_PROSPECT],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.PROSPECT_REP]
            }
        ],
        adminTools: []
    },
    {
        menuId: 'benefits',
        menuLabel: 'Benefits',
        menuLink: '',
        hasSubMenu: true,
        isActive: true,
        adminToolsHeading: null,
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Privileges.CUSTOM, Privileges.CUSTOM_ADD],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_CSA_USERS_REP, AD_GROUPS.MANAGE_CSA_USERS_ADMIN, AD_GROUPS.BENEFIT_LOOKUP_REP, AD_GROUPS.MEMBER_PAYMENT_ADMIN, AD_GROUPS.MEMBER_ADMIN, AD_GROUPS.MEMBER_REP, AD_GROUPS.PROVIDER_REP, AD_GROUPS.PROVIDER_ADMIN, AD_GROUPS.PROVIDER_REP_TAX, AD_GROUPS.EMPLOYER_REP, AD_GROUPS.EMPLOYER_ADMIN, AD_GROUPS.EMPLOYER_RPT, AD_GROUPS.SELF_FUNDED_ADMIN, AD_GROUPS.TPA_REP, AD_GROUPS.PRODUCER_REP, AD_GROUPS.PRODUCER_DSA, AD_GROUPS.PRODUCER_ADMIN, AD_GROUPS.PROSPECT_REP, AD_GROUPS.PROSPECT_ADMIN, AD_GROUPS.MANAGE_OEP_ADMIN],
        customerAssistanceTools: [
            {
                subMenuId: 'benefitLookup',
                subMenuLabel: 'Benefit Lookup',
                subMenuLink: '/benefits/benefit-lookup',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_CSA_USERS_REP, AD_GROUPS.MANAGE_CSA_USERS_ADMIN, AD_GROUPS.BENEFIT_LOOKUP_REP, AD_GROUPS.MEMBER_PAYMENT_ADMIN, AD_GROUPS.MEMBER_ADMIN, AD_GROUPS.MEMBER_REP, AD_GROUPS.PROVIDER_REP, AD_GROUPS.PROVIDER_ADMIN, AD_GROUPS.PROVIDER_REP_TAX, AD_GROUPS.EMPLOYER_REP, AD_GROUPS.EMPLOYER_ADMIN, AD_GROUPS.EMPLOYER_RPT, AD_GROUPS.SELF_FUNDED_ADMIN, AD_GROUPS.TPA_REP, AD_GROUPS.PRODUCER_REP, AD_GROUPS.PRODUCER_DSA, AD_GROUPS.PRODUCER_ADMIN, AD_GROUPS.PROSPECT_REP, AD_GROUPS.PROSPECT_ADMIN, AD_GROUPS.MANAGE_OEP_ADMIN]
            }
        ],
        adminTools: []
    },
    {
        menuId: 'manageCsaUsers',
        menuLabel: 'Manage CSA Users',
        menuLink: '',
        hasSubMenu: true,
        adminToolsHeading: 'ADMIN TOOLS',
        isActive: true,
        accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_CSA_USERS_REP, AD_GROUPS.MANAGE_CSA_USERS_ADMIN],
        customerAssistanceTools: [
            {
                subMenuId: 'myProfile',
                subMenuLabel: 'My Profile',
                subMenuLink: '/my-profile',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE, Roles.USER_MANAGER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_CSA_USERS_REP, AD_GROUPS.MANAGE_CSA_USERS_ADMIN]
            },
            {
                subMenuId: 'createOrModifyCsaUsers',
                subMenuLabel: 'Create/Modify CSA Users',
                subMenuLink: '/manage-csa-users/search-user',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                adGroupAccessIds: []  // Hidden for all AD users
            }
        ],
        adminTools: [
            {
                subMenuId: 'csaUserReport',
                subMenuLabel: 'CSA User Report',
                subMenuLink: '/manage-csa-users/reports',
                linkType: 'route',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_CSA_USERS_ADMIN]
            },
            {
                subMenuId: 'providerActivityReport',
                subMenuLabel: 'Provider Activity Report',
                subMenuLink: 'callProviderActivitySplunk',
                linkType: 'method',
                openInNewTab: true,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_CSA_USERS_ADMIN]
            },
            {
                subMenuId: 'employerActivityReport',
                subMenuLabel: 'Employer Activity Report',
                subMenuLink: 'callEmployerActivitySplunk',
                linkType: 'method',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_CSA_USERS_ADMIN]
            },
            {
                subMenuId: 'memberActivityReport',
                subMenuLabel: 'Member Activity Report',
                subMenuLink: 'callMemberActivitySplunk',
                linkType: 'method',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_CSA_USERS_ADMIN]
            },
            {
                subMenuId: 'prospectActivityReport',
                subMenuLabel: 'Prospect Activity Report',
                subMenuLink: 'callProspectActivitySplunk',
                linkType: 'method',
                openInNewTab: false,
                hasAccess: false,
                accessIds: [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.USER_MANAGER],
                adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_CSA_USERS_ADMIN]
            }

        ]
    },
    {
        menuId: 'manageOem',
        menuLabel: 'Manage OEP',
        menuLink: '/manage-oep',
        hasSubMenu: false,
        isActive: true,
        adminToolsHeading: null,
        accessIds: [Roles.SUPER_ADMIN],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MANAGE_OEP_ADMIN],
        customerAssistanceTools: [],
        adminTools: []
    },
    {
        menuId: 'ccm',
        menuLabel: 'CCM',
        menuLink: '/ccm',
        hasSubMenu: false,
        isActive: true,
        adminToolsHeading: null,
        accessIds: [Roles.SUPER_ADMIN, Privileges.CCM_MEMBER, Privileges.CCM_PROSPECT, Privileges.CCM_PROVIDER, Privileges.CCM_PRODUCER, Privileges.CCM_EMPLOYER],
        adGroupAccessIds: [AD_GROUPS.SUPER_ADMIN, AD_GROUPS.MEMBER_REP],
        customerAssistanceTools: [],
        adminTools: []
    }
    ];
}
